import { useEffect, useRef } from 'react';
import { showActiveMobile } from 'lib/container/ActiveMobile';
import { showThirdPartyLogin } from 'lib/components/ThirdPartyLogin';
import { LOGIN_TYPE } from 'lib/constants/login';
import { MOBILE_ACTIVE_STATE } from 'lib/constants/order';
import mobileOrderPackageService from 'lib/services/mobileOrderPackageService';
import { useMobileStore } from 'lib/store/mobileStore';
import session from 'lib/utils/session';
import storage from 'lib/utils/storage';
import { STORAGE } from 'lib/utils/storage/constants';
import { validMobile } from 'lib/utils/util';
import TipsModalV2 from 'lib/components/Modal/TipsModalV2';
import { showOrderMobileInput } from 'lib/components/MobileInput';
import { TIPS_MSG } from 'lib/constants/error';
import { useProtocolStore } from 'lib/store/protocol';
import { gateway } from 'lib/utils/authMobile/gatewayMobile';
import { report } from 'lib/utils/dataReport';
import { ATTA_GATEWAY_MOBILE } from 'lib/constants/atta';
import toast from 'lib/utils/toast';

export const useMobileOrder = () => {
  const {
    activeState,
    inputMobile,
    queryMobile,
    mobileBindLoginType,
    queryMobileOrderStatus,
    gatewayMobile,
  } = useMobileStore((state) => ({
    isAllowed: state.isAllowed,
    activeState: state.activeState,
    inputMobile: state.inputMobile,
    queryMobile: state.queryMobile,
    mobileBindLoginType: state.mobileBindLoginType,
    queryMobileOrderStatus: state.queryMobileOrderStatus,
    gatewayMobile: state.gatewayMobile,
  }));
  const init = useRef(false);

  useEffect(() => {
    // 当输入框手机号和历史查询手机号不一致时，不主动提示激活
    if (queryMobile && inputMobile && inputMobile !== queryMobile) {
      return;
    }
    /**
     * 1、访问前存在手机号记录，并调用手机号激活状态查询
     * 2、判断手机号是否允许订购，并处理激活状态
     */
    if (queryMobile && !init.current && activeState !== MOBILE_ACTIVE_STATE.NO_NEED_ACTIVE) {
      init.current = true;
      // storage.setStorage(STORAGE.ORDER_MOBILE, queryMobile);
      handleActiveProcess(activeState, mobileBindLoginType);
    }
  }, [queryMobile, activeState, mobileBindLoginType]);

  // 提交订单
  const orderFlowPackage = async (activityId) => {
    const { useGatewayMobile } = useMobileStore.getState();
    if (!useGatewayMobile && !validMobile(inputMobile)) {
      showOrderMobileInput();
      return;
    }

    const order = async () => {
      if (useGatewayMobile) {
        const mobileToken = await gateway.getMobileToken();
        // 未获取到token，提示输入手机号
        if (!mobileToken) {
          showOrderMobileInput();
          toast.info('获取手机号失败，请重新输入手机号');
          return;
        }
      }
      // 进入订购流程
      const data = await queryMobileOrderStatus(inputMobile);
      if (!data) {
        return;
      }
      const isMobileOrdered = !data?.isAllowed;
      const mobileActiveState = data?.activeState || MOBILE_ACTIVE_STATE.NO_NEED_ACTIVE;
      const userType = data?.mobileBindLoginType || LOGIN_TYPE.NONE;
      if (inputMobile) {
        storage.setStorage(STORAGE.ORDER_MOBILE, inputMobile);
      }
      // 手机号已订购
      if (isMobileOrdered) {
        // 判断是否登录
        const isLogin = await session.checkIsLogin();
        if (!isLogin) {
          showThirdPartyLogin({
            isBinding: true,
            lastUserType: userType,
          });
          return;
        }

        if (mobileActiveState === MOBILE_ACTIVE_STATE.NO_NEED_ACTIVE) {
          // 当前手机号已订购流量包
          TipsModalV2.show({
            content: TIPS_MSG.MOBILE_ORDERED,
          });
          return;
        }

        // 根据activeState走激活流程
        handleActiveProcess(mobileActiveState, userType);
        return;
      }

      // 走订购流程
      if (mobileActiveState === MOBILE_ACTIVE_STATE.NO_NEED_ACTIVE) {
        mobileOrderPackageService.handleOrderFlowPackage(inputMobile || gatewayMobile, activityId);
        return;
      }
    };

    const { isCheckedProtocol, showProtocolDialog } = useProtocolStore.getState();
    if (useGatewayMobile && !isCheckedProtocol) {
      showProtocolDialog({
        buttonText: '同意',
        onConfirm: async () => {
          report(ATTA_GATEWAY_MOBILE.AGREEMENT_CONFIRM);
          const { setIsCheckedProtocol } = useProtocolStore.getState();
          setIsCheckedProtocol(true);
          order();
        },
      });
      return;
    }
    order();
  };

  // 激活订单
  const handleActiveProcess = async (activeState, mobileBindLoginType) => {
    switch (activeState) {
      case MOBILE_ACTIVE_STATE.NOT_ACTIVE: {
        const isLogin = await session.checkIsLogin();
        if (isLogin) {
          // 弹出验证码
          showActiveMobile({
            mobile: inputMobile || gatewayMobile,
          });
          return;
        }
        // 弹出登录，记录上一次登录状态
        showThirdPartyLogin({
          isBinding: true,
          lastUserType: mobileBindLoginType,
        });
        return;
      }

      case MOBILE_ACTIVE_STATE.ACTIVE: {
        const isLogin = await session.checkIsLogin();
        if (isLogin) {
          // 当前手机号已订购流量包
          TipsModalV2.show({
            content: TIPS_MSG.MOBILE_ORDERED,
          });
          return;
        }
        // 弹出登录

        showThirdPartyLogin({
          lastUserType: mobileBindLoginType,
        });
        return;
      }
    }
  };

  return {
    orderFlowPackage,
  };
};
